<template>
  <div class="category-management">
    <page-title title="banner配置">
      <div class="category-management__body">
        <div class="opt-box">
          <el-button type="primary" size="default" @click="handleCreate"
            >新建banner</el-button
          >
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          v-loading="loading"
        >
          <el-table-column prop="sort" width="100" label="排序">
          </el-table-column>
          <el-table-column prop="pictureUrl" label="banner图片">
            <template slot-scope="scope">
              <el-image
                class="banner-img"
                :src="fileEcho + scope.row.pictureUrl"
                :preview-src-list="[fileEcho + scope.row.pictureUrl]"
                fit="cover"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="position" label="位置">
            <template slot-scope="scope">
              {{ scope.row.position == 1 ? "首页" : "知识库" }}
            </template>
          </el-table-column>
          <el-table-column prop="url" label="跳转链接"> </el-table-column>
          <el-table-column prop="opt" label="操作">
            <template slot-scope="scope">
              <el-button class="edit" type="text" @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                :disabled="scope.$index == 0"
                class="edit"
                type="text"
                @click="move('up', scope.row)"
                >上移</el-button
              >
              <el-button
                :disabled="scope.$index == tableData.length - 1"
                class="edit"
                type="text"
                @click="move('down', scope.row)"
                >下移</el-button
              >
              <el-button
                v-if="tableData.length > 1"
                class="edit"
                type="text"
                @click="deleteRow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="pageOn"
          :page-size.sync="pageSize"
          @current-change="getList"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
    <creataBanner
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :currentBanner="currentBanner"
      @refresh="queryList"
    ></creataBanner>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import { bannerList, bannerDelete, bannerUpAndDown } from "@/api/banner";
import { fileEcho } from "@/api/url";
import creataBanner from "./components/createBannerDialog.vue";
import CusPagination from "@/components/cusPagination.vue";
export default {
  components: {
    PageTitle,
    creataBanner,
    CusPagination,
  },
  data() {
    return {
      fileEcho,
      dialogVisible: false,
      total: 0,
      pageSize: 10,
      pageOn: 1,
      tableData: [
        {
          sort: 1,
        },
      ],
      currentBanner: {},
      loading: false,
    };
  },
  methods: {
    queryList() {
      this.pageOn = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$ajax
        .get(bannerList, {
          pageOn: this.pageOn,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
            this.loading = false;
          }
        });
    },
    deleteRow(row) {
      this.$confirm("此操作将删除该banner, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax.delete(bannerDelete(row.id)).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleEdit(row) {
      this.currentBanner = row;
      this.dialogVisible = true;
    },
    handleCreate() {
      this.currentBanner = {};
      this.dialogVisible = true;
    },
    move(type, row) {
      const { id } = row;
      const currentIndex = this.tableData.findIndex((item) => item.id === id);
      let targetSort;
      if (type === "up" && currentIndex > 0) {
        targetSort = this.tableData[currentIndex - 1].sort;
      } else if (type === "down" && currentIndex < this.tableData.length - 1) {
        targetSort = this.tableData[currentIndex + 1].sort;
      }
      this.upAndDownApi({ id, sort: targetSort });
    },
    async upAndDownApi(data) {
      const { data: res } = await this.$ajax.get(bannerUpAndDown, data);
      if (res.code === 200) {
        this.getList();
      }
    },
  },

  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }
  .opt-box {
    text-align: right;
    margin-bottom: 20px;
  }
  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
  .banner-img {
    width: 224px;
    height: 112px;
    border-radius: 4px;
  }
}
</style>
